/* eslint-disable max-len */
import { usersList } from "./apiSlice";

const alertsList = usersList.injectEndpoints({
    tagTypes: ['Alerts',],
    endpoints: (builder) => ({
       
        acknowledgeAlert: builder.mutation({
            query: (id) => ({
                url: `patients/alert-acknowledge/${id}?is_acknowledged=true`,
                method: 'POST',
                body: {
                    "status": "Acknowledged"
                }
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'Alerts', id: arg.id }]
        }),
        deviceDetails:builder.query({
            query:(id)=>`/users/${id}`,
            
            providesTags:(result=[],error,arg)=>error===undefined?[
                'device',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'device',id:_id}))
            ]:[],
        }),
        wellnessDropdownGetData: builder.query({
            query: (searchParams) => ({
                url: `patients/alerts-dropdown${searchParams}`,
                method: 'GET',
               
            }),
        }),
        getWellnessNotesList: builder.query({
            query: (searchParams) => ({
                url: `patients/list-all-wellness-notes?${searchParams}`,
                method: 'GET',
               
            }),
        }),
        exportWellnessNotesList: builder.mutation({
            query: ({ queryString, columns, dateformat }) => ({
                url: `patients/export-wellness-reports?${queryString}`,
                method: 'POST',
                body: { "columns": columns, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
            }),
        }),
        exportDeviceAlertList: builder.mutation({
            query: ({ queryString, columns, dateformat }) => ({
                url: `patients/export-device-alerts?${queryString}`,
                method: 'POST',
                body: { "columns": columns, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
            }),
        }),
        exportProviderAlertReportList: builder.mutation({
            query: ({ queryString, columns, dateformat }) => ({
                url: `patients/list-providers-alerts-report/export?${queryString}`,
                method: 'POST',
                body: { "columns": columns, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
            }),
        }),
    }),
   
    overrideExisting: false
})


export const {
    useAcknowledgeAlertMutation,
    useLazyDeviceDetailsQuery,
    useWellnessDropdownGetDataQuery,
    useGetWellnessNotesListQuery,
    useExportWellnessNotesListMutation,
    useExportDeviceAlertListMutation,
    useExportProviderAlertReportListMutation

} = alertsList